var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partners"},[(_vm.type == 'financial')?[_c('financial')]:_vm._e(),(_vm.type == 'farming')?[_c('farming')]:_vm._e(),(_vm.type == 'num')?[_c('num')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }